<template>
  <section class="underwriting-refer">
    <div class="table">
      <div class="tr">
        <span>Studying Country</span>
        <!--        <span>{{ getAllOptionName25('study_country', quoteForm.country_id) }}</span>-->
        <span v-if="quoteForm.country_id!=3">{{getAllOptionName25('study_country',quoteForm.country_id)}}</span>
        <span v-else>{{getAllOptionName25('study_country',quoteForm.country_id)}} - {{quoteForm.other_country}}</span>

      </div>
      <div class="tr">
        <span>Studying Full-time?</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.is_full_time) }}</span>
      </div>
      <div class="tr">
        <span>Student Age</span>
        <span>{{ quoteForm.student_age }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions25
    },
  }
}
</script>
